import http from './httpService';
import { baseUrl } from '../utils/helper';

const apiEndpoint = `${baseUrl}/api/analytics`;

export function sendMonitorNotif({ type, userId, source, error }: any) {
  const data = JSON.stringify({ type, userId, source, error });
  const blob = new Blob([data], { type: 'application/json' });
  navigator.sendBeacon(`${apiEndpoint}/monitor_notif`, blob);
}

export const sendSearchEvent = (data: any) => {
  const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
  navigator.sendBeacon(`${apiEndpoint}/add-search-event`, blob);
};

export const getAllSearchEvents = (country?: string, range?: string) => {
  const params = new URLSearchParams();

  if (country && country !== 'ALL') {
    params.append('isoCodeCountry', country);
  }

  if (range && range !== 'all') {
    params.append('range', range); // values: 'daily', 'monthly', 'yearly'
  }

  return http.get(`${apiEndpoint}/search-events${params.toString() ? `?${params}` : ''}`);
};

export const getAllMetrics = (country?: string, range?: string) => {
  const params = new URLSearchParams();

  if (country && country !== 'ALL') {
    params.append('isoCodeCountry', country);
  }

  if (range && range !== 'all') {
    params.append('range', range); // same as above
  }

  return http.get(`${apiEndpoint}/search-metrics${params.toString() ? `?${params}` : ''}`);
};
